
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

export default {
data () {
return {
value1:"",
muSid:'',
value3:['本人'],
list1:[["亲戚","老师","朋友"]],
phones:'',
openids:''
}
},
beforeMount(){
this.muSid = this.$router.history.current.query.msId;
this.phones = this.$router.history.current.query.phone;
this.openids = this.$router.history.current.query.openid;
let urls = global.host + 'users/personalCenter';
this.$http.get(urls).then(function(res){

},function(err){
console.log(err)
})
},
components: {
PopupHeader,
Group,
XInput,
PopupPicker
},
methods:{
cancle(){
this.$router.push({path:'/userinfo',query:{openid:this.openids,phone:this.phones}})

},
colectMethod(){
let urls = global.host + 'users/personalCenter';
this.$http.get(urls).then(function(res){
this.$router.push({path:'/userinfo',query:{openid:openids,phone:phones}})
},function(err){
console.log(err)
})
},
onChanges(){

}
}
}



// WEBPACK FOOTER //
// ./src/components/userComponents/editUserInformation.vue